import './App.css';
import React, { useState, useEffect } from 'react';
import DocumentMeta from 'react-document-meta';
import StripeCheckout from 'react-stripe-checkout';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import moment from 'moment-timezone';

import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import MessageIcon from '@mui/icons-material/Message';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import SendIcon from '@mui/icons-material/Send';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

function App() {
  const [loading, setLoading] = useState(true);
  const [linkValid, setLinkValid] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [success, setSuccess] = useState(true);

  const [accountId, setAccountId] = useState('');
  const [backgroundImage, setBackgroundImage] = useState('');
  const [backgroundColor, setBackgroundColor] = useState('#e6e6e6');
  const [bannerImage, setBannerImage] = useState('');
  const [businessName, setBusinessName] = useState('Online Voucher');
  const [businessPhone, setBusinessPhone] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [currency, setCurrency] = useState('$');
  const [checkoutCurrency, setCheckoutCurrency] = useState('AUD');
  const [stripeConnectedId, setStripeConnectedId] = useState('');
  const [onlineBookingsEnabled, setOnlineBookingsEnabled] = useState(false);
  const [onlineBookingsUrl, setOnlineBookingsUrl] = useState('');
  const [onlineVoucherUrl, setOnlineVoucherUrl] = useState('');
  const [addFees, setAddFees] = useState(false);

  const [presetVouchers, setPresetVouchers] = useState([]);
  const [allowPresetVouchers, setAllowPresetVouchers] = useState(false);
  const [allowCustomVouchers, setAllowCustomVouchers] = useState(false);
  const [minimumValue, setMinimumValue] = useState(0);
  const [maximumValue, setMaximumValue] = useState(0);
  const [currentVoucherNumber, setCurrentVoucherNumber] = useState('');
  const [customVoucherExpiresIn, setCustomVoucherExpiresIn] = useState('3');
  const [alertDialogOpen, setAlertDialogOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showSummary, setShowSummary] = useState(false);

  // voucher info
  const [fromName, setFromName] = useState('');
  const [fromEmail, setFromEmail] = useState('');
  const [recipients, setRecipients] = useState([{
    toName: '',
    toEmail: '',
    message: '',
    selectedVoucherId: '',
    voucherValue: 0,
    voucherPrice: 0,
    voucherExpires: moment().format('DD/MM/YYYY'),
    expiresIn: '0',
    voucherDescription: ''
  }]);

  useEffect(() => {
    const fetchBusinessDetails = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('business')) {
        setLinkValid(false);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post('https://app1.clientdiary.com/api/call-method', {
          method: 'getBusinessDetailsOnlineVouchers',
          params: [urlParams.get('business')]
        });
        const result = response.data.result;

        // const response = await axios.post('https://app.clientdiary.com/methods/getBusinessDetailsOnlineVouchers', [urlParams.get('business')]);
        // // const response = await axios.post('http://localhost:3000/methods/getBusinessDetailsOnlineVouchers', [urlParams.get('business')])
        // const result = response.data;

        if (result.available === false || (!result.testAccount && (result.subscription === undefined || (result.subscription.status !== 'active' && result.subscription.status !== 'trialing' && result.subscription.status !== 'past_due')))) {
          setLinkValid(false);
          setLoading(false);
        } else {
          const sortAlphaNum = (a, b) => a.description.localeCompare(b.description, 'en', { numeric: true });
          let sortedPresetVouchers = result.presetVouchers.sort(sortAlphaNum);

          setAccountId(result.accountId);
          setBackgroundImage(result.backgroundImage === undefined ? '' : result.backgroundImage);
          setBackgroundColor(result.backgroundColor === undefined ? '#e6e6e6' : result.backgroundColor);
          setBannerImage(result.bannerImage === undefined ? '' : result.bannerImage);
          setBusinessName(result.businessName);
          setStripeConnectedId(result.stripeConnectedId);
          setBusinessPhone(result.businessPhone);
          setLogoUrl(result.logoUrl);
          setPresetVouchers(sortedPresetVouchers);
          setAllowPresetVouchers(result.allowPresetVouchers);
          setAllowCustomVouchers(result.allowCustomVouchers);
          setMinimumValue(result.minimumValue);
          setMaximumValue(result.maximumValue);
          setCurrentVoucherNumber(result.currentVoucherNumber);
          setCustomVoucherExpiresIn(result.customVoucherExpiresIn);
          setTermsAndConditions(result.termsAndConditions);
          setCurrency(result.currency);
          setCheckoutCurrency(result.checkoutCurrency);
          setOnlineBookingsEnabled(result.onlineBookingsEnabled);
          setOnlineBookingsUrl(result.onlineBookingsUrl);
          setAddFees(result.addFees);
          setOnlineVoucherUrl(urlParams.get('business'));

          if (urlParams.has('result')) {
            setSubmitted(true);
            setSuccess(urlParams.get('result') === 'success' ? true : false);
          }

          setLoading(false);
        }
      } catch (error) {
        console.log(error);
        setLinkValid(false);
        setLoading(false);
      }
    };

    fetchBusinessDetails();
  }, []);

  const getComputedStyle = () => {
    let mainStyle = {
      flex: 1
    };

    let backgroundImageStyle = '';
    if (backgroundImage !== '') {
      backgroundImageStyle = 'url(' + backgroundImage + ')';
    }

    if (backgroundImage.includes('Default')) {
      mainStyle.backgroundColor = backgroundColor;
    } else if (backgroundImage !== '') {
      mainStyle.backgroundImage = backgroundImageStyle;
      mainStyle.backgroundRepeat = 'repeat';
    }

    return mainStyle
  }

  const getAuthor = () => {
    let author = '';
    
    if (backgroundImage !== '') {
      if (backgroundImage.includes('BSGStudio')) {
        author = 'BSGStudio';
      } else if (backgroundImage.includes('freedesignfile')) {
        author = 'freedesignfile';
      } else if (backgroundImage.includes('peecheey')) {
        author = 'peecheey';
      } else if (backgroundImage.includes('webdesignhot')) {
        author = 'webdesignhot';
      }
    }

    return author
  }

  const handleAddNewRecipient = () => {
    let tempRecipients = [...recipients];
    tempRecipients.push({
      toName: '',
      toEmail: '',
      message: '',
      selectedVoucherId: '',
      voucherValue: 0,
      voucherPrice: 0,
      voucherExpires: moment().format('DD/MM/YYYY'),
      expiresIn: '0',
      voucherDescription: ''
    });

    setShowSummary(false);
    setRecipients(tempRecipients);
  }

  const handleClickContinueToSummary = () => {
    if (recipients.find(r => r.toName === '') !== undefined) {
      setAlertDialogOpen(true);
      setAlertMessage('Recipient must have a name.');

      return;
    }

    if (recipients.find(r => r.selectedVoucherId === '') !== undefined) {
      setAlertDialogOpen(true);
      setAlertMessage('Please select voucher.');

      return;
    }

    if (recipients.find(r => r.selectedVoucherId === 'custom' && (Number(r.voucherValue) < Number(minimumValue) || Number(r.voucherValue) > Number(maximumValue))) !== undefined) {
      setAlertDialogOpen(true);
      setAlertMessage('Voucher value must be between ' + currency + minimumValue + ' and ' + currency + maximumValue);

      return;
    }

    setShowSummary(true);
  }

  const handleChangeToName = (index, e) => {
    let tempRecipients = [...recipients];
    tempRecipients[index].toName = e.target.value;

    setShowSummary(false);
    setRecipients(tempRecipients);
  }

  const handleChangeToEmail = (index, e) => {
    let tempRecipients = [...recipients];
    tempRecipients[index].toEmail = e.target.value;

    setShowSummary(false);
    setRecipients(tempRecipients);
  }

  const handleChangeMessage = (index, e) => {
    let tempRecipients = [...recipients];
    tempRecipients[index].message = e.target.value;

    setShowSummary(false);
    setRecipients(tempRecipients);
  }

  const handleChangeSelectedVoucher = (index, e) => {
    let tempRecipients = [...recipients];
    tempRecipients[index].selectedVoucherId = e.target.value;

    if (e.target.value !== 'custom') {
      let selectedPreset = presetVouchers.find(voucher => voucher._id === e.target.value);
      tempRecipients[index].voucherValue = (selectedPreset.value / 100).toFixed(2);
      tempRecipients[index].voucherPrice = (selectedPreset.price / 100).toFixed(2);
      tempRecipients[index].voucherExpires = (selectedPreset.expiresIn === '0' ? 'Never expires' : moment().add(Number(selectedPreset.expiresIn), 'month').format('DD/MM/YYYY'));
      tempRecipients[index].expiresIn = selectedPreset.expiresIn;
      tempRecipients[index].voucherDescription = selectedPreset.description;
    } else {
      tempRecipients[index].voucherExpires = (customVoucherExpiresIn === '0' ? 'Never expires' : moment().add(Number(customVoucherExpiresIn), 'month').format('DD/MM/YYYY'));
      tempRecipients[index].expiresIn = customVoucherExpiresIn;
      tempRecipients[index].voucherDescription = 'Custom Voucher';
    }

    setShowSummary(false);
    setRecipients(tempRecipients);
  }

  const handleChangeVoucherValue = (index, e) => {
    let tempRecipients = [...recipients];
    tempRecipients[index].voucherValue = e.target.value;
    tempRecipients[index].voucherPrice = e.target.value;

    setShowSummary(false);
    setRecipients(tempRecipients);
  }

  const handleRemoveRecipient = (index) => {
    let tempRecipients = [...recipients];
    tempRecipients.splice(index, 1);

    setShowSummary(false);
    setRecipients(tempRecipients);
  }

  const calculateAmount = () => {
    let amountToPay = recipients.reduce((prev, cur) => prev + Number(cur.voucherPrice), 0) * 100;
    if (addFees) {
      // stripe fees 1.7% + A$0.30
      // clientDiaryFees is 1.05%
      const originalAmount = Math.ceil(Number(amountToPay));
      const clientDiaryFees = Math.ceil(0.0105 * originalAmount);
      // addFees option is ON => calculate fees base on Stripe's formula
      // price_charge = (price_goal + fee_fixed) / (1 - fee_percentage)
      amountToPay = Math.ceil((originalAmount + 30 + clientDiaryFees) / (1 - 0.017));
      // const fees = price_charge - originalAmount;
    }

    return amountToPay
  }

  const clickPayWithCard = async () => {
    const stripePromise = loadStripe('pk_live_d7KO18UnRkBTgKHDqZt67xcY', {
      stripeAccount: stripeConnectedId
    });

    // const stripePromise = loadStripe('pk_test_XkbNpvXMxV5Q5OKVYFgQMhHS', {
    //   stripeAccount: stripeConnectedId
    // });

    const stripe = await stripePromise;

    let amountToPayWithoutFees = recipients.reduce((prev, cur) => prev + Number(cur.voucherPrice), 0) * 100;
    let amountToPay = recipients.reduce((prev, cur) => prev + Number(cur.voucherPrice), 0) * 100;
    let sender = {
      name: fromName,
      email: fromEmail
    };

    const originalAmount = Math.ceil(Number(amountToPay));
    const clientDiaryFees = Math.ceil(0.0105 * originalAmount);
    if (addFees) {
      // stripe fees 1.7% + A$0.30
      // clientDiaryFees is 1.05%
      // addFees option is ON => calculate fees base on Stripe's formula
      // price_charge = (price_goal + fee_fixed) / (1 - fee_percentage)
      amountToPay = Math.ceil((originalAmount + 30 + clientDiaryFees) / (1 - 0.017));
      // const fees = price_charge - originalAmount;
    }

    setSubmitting(true);

    try {
      const response = await axios.post('https://app1.clientdiary.com/api/call-method', {
        method: 'createCheckoutSessionVoucher',
        params: [amountToPay, sender, recipients, accountId, amountToPayWithoutFees, clientDiaryFees, stripeConnectedId, checkoutCurrency, addFees, onlineVoucherUrl]
      });
      const session = response.data.result;
      
      // const response1 = await axios.post('https://1f32b2d9feab.ngrok-free.app/methods/createCheckoutSessionVoucher', [amountToPay, sender, recipients, accountId, amountToPayWithoutFees, clientDiaryFees, stripeConnectedId, checkoutCurrency, addFees, onlineVoucherUrl]);
      // // const response1 = await axios.post('http://localhost:3000/methods/createCheckoutSessionVoucher', [amountToPay, sender, recipients, accountId, amountToPayWithoutFees, clientDiaryFees, stripeConnectedId, checkoutCurrency, addFees, onlineVoucherUrl])
      // const session = response1.data;

      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      if (result && result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
      alert(result.error.message);
      }
    } catch (error) {
      console.log(error);
      setSubmitting(false);
      setSubmitted(true);
      setSuccess(false);
    }
  }

  const renderContent = () => {
    if (!linkValid) {
      return (
        <Grid>
          <Card variant="outlined" style={{ margin: 10 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>Online Voucher link is incorrect</Typography>
              <Typography variant="h6" gutterBottom>What should I do?</Typography>
              <Typography variant="body1" gutterBottom>♦ Please contact the salon and double check the online voucher link.</Typography>
              <br />
              <Typography variant="body2">Thank you,</Typography>
              <br />
              <Typography variant="body2"><strong><i>{businessName}</i></strong></Typography>
            </CardContent>
          </Card>
        </Grid>
      )
    } else {
      if (submitted) {
        return (
          <Grid>
            <Card variant="outlined" style={{ margin: 10 }}>
              { success ?
                <CardContent>
                  <Typography variant="h5" gutterBottom>Thanks {fromName} for using our online vouchers service.</Typography>
                  <Typography variant="h6" gutterBottom>What's next?</Typography>
                  <Typography variant="body1" gutterBottom>♦ We will send the voucher to the recipient's address with your message.</Typography>
                  <Typography variant="body1" gutterBottom>♦ If no recipient's address is nominated, the voucher will be sent to your email address.</Typography>
                  <br />
                  <Typography variant="body2">Thank you and we look forward to seeing you.</Typography>
                  <br />
                  <Typography variant="body2"><strong><i>{businessName}</i></strong></Typography>
                  <Typography variant="body2"><strong><i>{businessPhone}</i></strong></Typography>
                  <br />
                  <Typography variant="subtitle2"><i>You can now safely close this page.</i></Typography>
                  <br />
                  <Button variant="contained" color="primary" onClick={() => {
                    const urlParams = new URLSearchParams(window.location.search);
                    window.location = 'https://voucher.clientdiary.com/?business=' + urlParams.get('business');
                  }}>
                    Buy another voucher
                  </Button>
                </CardContent>
                :
                <CardContent>
                  <Typography variant="h5" gutterBottom>Thanks {fromName} for using our online vouchers service.</Typography>
                  <Typography variant="h6" gutterBottom style={{ color: 'red' }}><strong>Unfortunately, an error has occured.</strong></Typography>
                  <Typography variant="body1" gutterBottom>♦ Please contact us and we will help you with your purchase.</Typography>
                  <br />
                  <Typography variant="body2">Thank you and we look forward to hearing from you.</Typography>
                  <br />
                  <Typography variant="body2"><strong><i>{businessName}</i></strong></Typography>
                  <Typography variant="body2"><strong><i>{businessPhone}</i></strong></Typography>
                  <br />
                  <Typography variant="subtitle2"><i>You can now safely close this page.</i></Typography>
                  <br />
                  <Button variant="contained" color="primary" onClick={() => {
                    const urlParams = new URLSearchParams(window.location.search);
                    window.location = 'https://voucher.clientdiary.com/?business=' + urlParams.get('business');
                  }}>
                    Buy another voucher
                  </Button>
                </CardContent>
              }
            </Card>
          </Grid>
        )
      } else {
        return (
          <>
            {onlineBookingsEnabled ?
              <Grid style={{ width: '100%' }}>
                <Card variant="outlined" style={{ margin: 10, backgroundColor: 'rgb(242, 245, 248)' }}>
                  <CardContent>
                    <div>{businessName} also offers you to book appointments online.</div>
                    <Button variant="contained" color="primary" style={{ marginTop: 10 }} href={"https://booking.clientdiary.com/?bookingsUrl=" + onlineBookingsUrl}>
                      Book Now
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              :
              null
            }
            <Grid style={{ width: '100%' }}>
              <Card variant="outlined" style={{ margin: 10, backgroundColor: 'rgb(242, 245, 248)' }}>
                <CardHeader title="Sender Details" />
                <CardContent style={{ paddingTop: 0 }}>
                  <div className="row">
                    <div className="col-xs-12 col-md-4 col-lg-4">
                      <Card style={{ margin: 10 }} variant="outlined">
                        <CardHeader title="From" />
                        <CardContent style={{ paddingTop: 0 }}>
                          <FormControl variant="outlined" fullWidth margin="normal">
                            <InputLabel>Name</InputLabel>
                            <OutlinedInput
                              value={fromName}
                              label="Name"
                              onChange={(e) => {
                                setShowSummary(false);
                                setFromName(e.target.value);
                              }}
                              startAdornment={
                                <InputAdornment position="start">
                                  <PersonIcon />
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                          <FormControl variant="outlined" fullWidth margin="normal">
                            <InputLabel>Email address</InputLabel>
                            <OutlinedInput
                              value={fromEmail}
                              onChange={(e) => {
                                setShowSummary(false);
                                setFromEmail(e.target.value);
                              }}
                              label="Email address"
                              startAdornment={
                                <InputAdornment position="start">
                                  <EmailIcon />
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid style={{ width: '100%' }}>
              <Card variant="outlined" style={{ margin: 10, backgroundColor: 'rgb(242, 245, 248)' }}>
                <CardHeader title="Voucher & Recipient Details" />
                <CardContent style={{ paddingTop: 0 }}>
                  <div className="row">
                    {renderRecipients()}
                    <div className="col-xs-12 col-md-4 col-lg-4">
                      <Card style={{ margin: 10 }} variant="outlined">
                        <CardContent>
                          <div className="center-xs">
                            <Button color="secondary" onClick={handleAddNewRecipient}>
                              Add new recipient
                            </Button>
                          </div>
                          <Divider style={{ marginTop: 15, marginBottom: 15 }} />
                          <div className="center-xs">
                            <Button variant="contained" color="primary" onClick={handleClickContinueToSummary}>
                              Continue to summary
                            </Button>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid style={{ width: '100%' }}>
              <Card variant="outlined" style={{ margin: 10, backgroundColor: 'rgb(242, 245, 248)' }}>
                <CardHeader title="Summary" />
                <CardContent style={{ paddingTop: 0 }}>
                  {showSummary === false ?
                    <p>Please complete all above sections.</p>
                    :
                    <div className="row">
                      <div className="col-xs-12 col-md-6 col-lg-6">
                        <Paper variant="outlined" style={{ padding: 15 }}>
                          <Typography variant="h5">Sender Details</Typography>
                          <List disablePadding>
                            <ListItem>
                              <ListItemIcon>
                                <SendIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary={fromName}
                                secondary={fromEmail}
                              />
                            </ListItem>
                          </List>
                          <Divider />
                          <Typography variant="h5" style={{ marginTop: 10 }}>Recipient Details</Typography>
                          {renderRecipientsSummary()}
                        </Paper>
                      </div>
                      <div className="col-xs-12 col-md-6 col-lg-6">
                        {termsAndConditions !== undefined || termsAndConditions !== '' ?
                          <Card variant="outlined">
                            <CardHeader title="Terms & Conditions" />
                            <CardContent>
                              <div style={{ whiteSpace: 'pre-line' }}>
                                {termsAndConditions}
                              </div>
                            </CardContent>
                          </Card>
                          :
                          null
                        }
                        <div className="center-xs" style={{ marginTop: 15 }}>
                          {/* <StripeCheckout
                            token={onToken}
                            stripeKey="pk_live_d7KO18UnRkBTgKHDqZt67xcY"
                            // stripeKey="pk_test_tY2vqLvUC8i09erGuku0JFiT"
                            name={businessName}
                            description="Online Vouchers Payment"
                            image={logoUrl}
                            ComponentClass="div"
                            panelLabel="Pay"
                            // amount={recipients.reduce((prev, cur) => prev + Number(cur.voucherPrice), 0) * 100}
                            amount={calculateAmount()}
                            currency={checkoutCurrency}
                            email={fromEmail}
                            allowRememberMe={false}
                          >
                            <Button variant="contained" color="primary" disabled={submitting ? true : false}>
                              {submitting ? <CircularProgress /> : "Pay With Card"}
                            </Button>
                          </StripeCheckout> */}

                          <Button variant="contained" color="primary" disabled={submitting ? true : false} onClick={clickPayWithCard}>
                            {submitting ? <CircularProgress /> : "Pay With Card"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  }
                </CardContent>
              </Card>
            </Grid>
            <Dialog
              open={alertDialogOpen}
              disableBackdropClick
              disableEscapeKeyDown
              maxWidth={false}
            >
              <DialogTitle>
                Alert
              </DialogTitle>
              <DialogContent>
                <div style={{ whiteSpace: 'pre-line' }}>
                  {alertMessage}
                </div>
              </DialogContent>
              <DialogActions>
                <Button color="primary" onClick={() => setAlertDialogOpen(false)}>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )
      }
    }
  }

  const renderRecipients = () => {
    return recipients.map((recipient, index) => {
      return (
        <div key={index} className="col-xs-12 col-md-4 col-lg-4">
          <Card style={{ margin: 10 }} variant="outlined">
            <CardHeader title={"To Recipient " + (index + 1)} />
            <CardContent>
              <Stack spacing={2}>
                <FormControl variant="outlined" fullWidth margin="normal" disabled>
                  <InputLabel>Voucher Number</InputLabel>
                  <OutlinedInput
                    value={'O-' + (currentVoucherNumber + index + 1).toString()}
                    label="Voucher Number"
                    startAdornment={
                      <InputAdornment position="start">
                        <LoyaltyIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel>Name</InputLabel>
                  <OutlinedInput
                    value={recipient.toName}
                    onChange={(e) => handleChangeToName(index, e)}
                    label="Name"
                    startAdornment={
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel>Email address</InputLabel>
                  <OutlinedInput
                    value={recipient.toEmail}
                    onChange={(e) => handleChangeToEmail(index, e)}
                    label="Email address"
                    startAdornment={
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    }
                  />
                  <FormHelperText>Leave blank to send voucher to your email address.</FormHelperText>
                </FormControl>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel>Message</InputLabel>
                  <OutlinedInput
                    value={recipient.message}
                    onChange={(e) => handleChangeMessage(index, e)}
                    label="Message"
                    startAdornment={
                      <InputAdornment position="start">
                        <MessageIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel>Select Voucher</InputLabel>
                  <Select
                    value={recipient.selectedVoucherId}
                    onChange={(e) => handleChangeSelectedVoucher(index, e)}
                    input={
                      <OutlinedInput
                        label="Select Voucher"
                        startAdornment={
                          <InputAdornment position="start">
                            <CardGiftcardIcon />
                          </InputAdornment>
                        }
                      />
                    }
                  >
                    {allowCustomVouchers ?
                      <MenuItem value="custom">
                        <em>Choose my own voucher value.</em>
                      </MenuItem>
                      :
                      null
                    }
                    {allowPresetVouchers ?
                      renderPresetVouchers()
                      :
                      null
                    }
                  </Select>
                </FormControl>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel>Voucher Value</InputLabel>
                  <OutlinedInput
                    type="number"
                    value={recipient.voucherValue}
                    disabled={recipient.selectedVoucherId === 'custom' ? false : true}
                    onChange={(e) => handleChangeVoucherValue(index, e)}
                    inputProps={{ min: minimumValue, max: maximumValue }}
                    label="Voucher Value"
                    startAdornment={
                      <InputAdornment position="start">
                        {currency}
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel>Purchase Price</InputLabel>
                  <OutlinedInput
                    value={recipient.voucherPrice}
                    disabled
                    label="Purchase Price"
                    startAdornment={
                      <InputAdornment position="start">
                        {currency}
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel>Expiry Date</InputLabel>
                  <OutlinedInput
                    value={recipient.voucherExpires}
                    disabled
                    label="Expiry Date"
                    startAdornment={
                      <InputAdornment position="start">
                        <EventBusyIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <div className="center-xs">
                  <Button color="error" onClick={() => handleRemoveRecipient(index)} disabled={index === 0 ? true : false} variant="outlined">
                    Remove Recipient
                  </Button>
                </div>
              </Stack>
            </CardContent>
          </Card>
        </div>
      )
    });
  }

  const renderPresetVouchers = () => {
    return presetVouchers.map((voucher, index) => {
      return (
        <MenuItem key={index} value={voucher._id}>
          {voucher.description} --- {currency}{(voucher.price / 100).toFixed(2)}
        </MenuItem>
      )
    })
  }

  const renderRecipientsSummary = () => {
    return recipients.map((recipient, index) => {
      return (
        <List key={index} disablePadding>
          <ListItem>
            <ListItemIcon>
              <CardGiftcardIcon />
            </ListItemIcon>
            <ListItemText
              primary={recipient.toName}
              secondary={recipient.toEmail}
            />
            {currency}{Number(recipient.voucherPrice).toFixed(2)}
          </ListItem>
          <ListItem>
            <ListItemText
              inset
              primary="Voucher Details"
              secondary={'Value: ' + currency + Number(recipient.voucherValue).toFixed(2) + ' / Expires: ' + recipient.voucherExpires}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              inset
              primary="Message"
              secondary={recipient.message}
            />
          </ListItem>
        </List>
      )
    })
  }

  return (
    <DocumentMeta {...{ title: businessName === '' ? 'Client Diary' : businessName }}>
      { loading ?
        <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <CircularProgress />
        </div>
        :
        <div className="app-root" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <div style={getComputedStyle()}>
            {bannerImage === '' &&
              <AppBar position="static">
                <Toolbar>
                  <Typography variant="h6" style={{ flexGrow: 1 }}>
                    {businessName}
                  </Typography>
                </Toolbar>
              </AppBar>
            }
            <div className="container">
              <Grid container direction="column" alignItems="center">
                { bannerImage === '' ?
                  null
                  :
                  <Grid>
                    <img src={bannerImage} style={{ maxWidth: '100%', maxHeight: '100%' }} alt="banner" />
                  </Grid>
                }
                {renderContent()}
              </Grid>
            </div>
          </div>
          <div style={{ backgroundColor: 'rgb(56, 67, 76)' }}>
            <div className="container">
              <div className="center-xs" style={{ margin: 10 }}>
                <div style={{ color: 'white', fontSize: 13 }}>
                  Online Voucher powered by <a href="https://clientdiary.com" target="_blank" rel="noreferrer" style={{ color: 'white' }}><b><i>Client Diary</i></b></a>
                </div>
                <div style={{ color: 'white', fontSize: 11, display: (getAuthor() === '' ? 'none' : '') }}>
                  Background image by {getAuthor()} from all-free-download.com
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </DocumentMeta>
  );
}

export default App;
